import React from "react";
import { Link } from "react-router-dom";
import LegalShell, { Section } from "@/components/LegalShell";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "@phosphor-icons/react";

export default function About() {
  return (
    <div data-testid="about-page">
      <LegalShell eyebrow="Our story" title={<>Curated matchmaking,<br /><em>for the Muslim ummah.</em></>}>
        <Section title="Why WR Rishtey">
          <p>
            WR Rishtey was born from a simple observation: Muslim families
            deserve better than swipe-driven apps that reduce a lifelong bond
            to a photograph. Nikah is a covenant — between two people, two
            families, and Allah <span className="text-brand-muted">(ﷻ)</span>.
            The way we begin it should reflect that.
          </p>
          <p>
            We are a hand-curated matchmaking concierge. A dedicated human
            matchmaker reviews every profile, cross-checks references, and
            assembles a discreet weekly shortlist. No infinite feed. No
            gamification. Just meaningful, family-endorsed introductions.
          </p>
        </Section>

        <Section title="Our values">
          <ul className="list-none space-y-3 pl-0">
            <li><strong className="text-brand-terracotta">Adab first.</strong> Every interaction on the platform respects the etiquette of Islam and the sanctity of family.</li>
            <li><strong className="text-brand-terracotta">Privacy as a duty.</strong> Contact details reveal only after both families accept. Profiles are never sold, exported, or advertised.</li>
            <li><strong className="text-brand-terracotta">Deen-aligned.</strong> We help you match on the things that endure — timeline, sect, salah, family involvement — not on filters that don't age well.</li>
            <li><strong className="text-brand-terracotta">Human, not algorithm.</strong> A real matchmaker will always be part of your journey. Software curates; a human decides.</li>
          </ul>
        </Section>

        <Section title="Who we serve">
          <p>
            WR Rishtey serves Muslim families around the world — from Hyderabad
            to Houston, from Karachi to Kuala Lumpur. Whether you are the
            brother/sister looking, or a parent, sibling, or friend creating
            a profile on their behalf, you are welcome here.
          </p>
        </Section>

        <div className="mt-16 border-t border-brand-line pt-10 flex items-center gap-4 flex-wrap">
          <Button asChild className="rounded-full bg-brand-terracotta hover:bg-brand-terracotta/90 text-white px-8 py-6" data-testid="about-cta-register">
            <Link to="/register">Begin your profile <ArrowRight size={16} className="ml-2" /></Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full border-brand-line px-8 py-6" data-testid="about-cta-contact">
            <Link to="/contact">Speak with a matchmaker</Link>
          </Button>
        </div>
      </LegalShell>
    </div>
  );
}
